import React from "react"
import Wrapper from "@components/Wrapper"
import WrapperInner from "@components/WrapperInner"

import styles from "./FAQ.module.scss"
import IntroDescription from "./IntroDescription"
import AccordionGroup from "./AccordionGroup"

const FAQ = props => {
  return (
    <WrapperInner className="row">
      <IntroDescription className={styles.introDescription} />
      <AccordionGroup />
    </WrapperInner>
  )
}

export default FAQ
